export const myCampaignsCategories = [
  'running_campaigns',
  'pending_campaigns',
  'completed_campaigns',
  'draft_campaigns',
];